"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScores = exports.defaultScoreData = exports.calcScoreAndRank = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
const defaultScoreData = exports.defaultScoreData = {
  id: 0,
  enabled: true,
  decFinalScore: 0,
  janFinalScore: 0,
  febFinalScore: 0,
  marFinalScore: 0,
  decWeek1FinalScore: 0,
  decWeek2FinalScore: 0,
  decWeek3FinalScore: 0,
  decWeek4FinalScore: 0,
  janWeek1FinalScore: 0,
  janWeek2FinalScore: 0,
  janWeek3FinalScore: 0,
  janWeek4FinalScore: 0,
  febWeek1FinalScore: 0,
  febWeek2FinalScore: 0,
  febWeek3FinalScore: 0,
  febWeek4FinalScore: 0,
  marWeek1FinalScore: 0,
  marWeek2FinalScore: 0,
  marWeek3FinalScore: 0,
  marWeek4FinalScore: 0,
  decPotential: 0,
  janPotential: 0,
  febPotential: 0,
  marPotential: 0,
  allTimeFinalScore: 0,
  zm: {
    id: 0,
    name: '',
    code: 0
  },
  rm: {
    id: 0,
    name: '',
    code: 0
  },
  am: {
    id: 0,
    name: '',
    code: 0
  },
  employee: {
    id: 0,
    name: '',
    code: 0
  },
  division: {
    id: 0,
    name: ''
  },
  zone: {
    id: 0,
    name: ''
  },
  brand: {
    id: 0,
    name: ''
  },
  doctor: {
    id: 0,
    name: ''
  },
  zmLocation: {
    id: 0,
    name: '',
    code: 0
  },
  rmLocation: {
    id: 0,
    name: '',
    code: 0
  },
  amLocation: {
    id: 0,
    name: '',
    code: 0
  },
  mrLocation: {
    id: 0,
    name: '',
    code: 0
  }
};
const getScores = params => (0, _request.default)({
  url: '/scores',
  method: 'get',
  params
});
exports.getScores = getScores;
const calcScoreAndRank = params => (0, _request.default)({
  url: '/rmScore',
  method: 'get',
  params
});
exports.calcScoreAndRank = calcScoreAndRank;